var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { UserPreferencesSchema } from "@grumpycorp/warm-and-fuzzy-shared";
import { computed, flow } from "mobx";
import { GraphqlMutableStoreBase } from "../GraphqlMutableStoreBase";
import gql from "graphql-tag";
const userPreferencesFragment = gql `
  fragment UserPreferencesStoreFields on UserPreferences {
    temperatureUnits
  }
`;
const thermostatConfigurationsStoreDocument = gql `
  ${userPreferencesFragment}
  query UserPreferencesStore {
    getUserPreferences {
      ...UserPreferencesStoreFields
    }
  }
`;
const updateUserPreferencesStoreDocument = gql `
  ${userPreferencesFragment}
  mutation UpdateUserPreferencesStore($userPreferences: UserPreferencesUpdateInput!) {
    updateUserPreferences(userPreferences: $userPreferences) {
      ...UserPreferencesStoreFields
    }
  }
`;
//
// Since our GraphqlStoreBase/GraphqlMutableStoreBase infrastructure is designed for arrays of items,
// we need to inflate/deflate the single user preferences item into/from arrays.
//
// We'll inject bogus `id` property that we build/strip in the extractor/builder functions below.
//
// In general, consumers of the store shouldn't have to care and should just use
// the userPreferences get property and updateUserPreferences().
//
const userPreferencesId = "me";
/* Member ordering gets too weird with annotations, generators, etc. */
/* eslint-disable @typescript-eslint/member-ordering */
let UserPreferencesStore = /** @class */ (() => {
    class UserPreferencesStore extends GraphqlMutableStoreBase {
        constructor(authStore, apolloClient) {
            super("UserPreferences", authStore, apolloClient, 
            // Mutation
            updateUserPreferencesStoreDocument, (item) => {
                // Remove injected `id` property
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { id } = item, remainder = __rest(item, ["id"]);
                return { userPreferences: remainder };
            }, 
            // Query
            thermostatConfigurationsStoreDocument, (queryData) => {
                // Inject `id` property, convert to fixed-sized array
                return [Object.assign(Object.assign({}, queryData.getUserPreferences), { id: userPreferencesId })];
            });
            this.updateUserPreferences = flow(function* (userPreferences) {
                const existingPreferences = this.userPreferences;
                const mergedPreferences = Object.assign(existingPreferences, userPreferences);
                return this.updateItem(Object.assign(Object.assign({}, mergedPreferences), { id: userPreferencesId }));
            });
        }
        get userPreferences() {
            if (this.data.length) {
                return this.data[0];
            }
            return UserPreferencesSchema.DefaultUserPreferences;
        }
    }
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], UserPreferencesStore.prototype, "userPreferences", null);
    return UserPreferencesStore;
})();
export { UserPreferencesStore };
//# sourceMappingURL=index.js.map